// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__jLPmj","chart__block":"styles_chart__block__NPjl5","chart__data":"styles_chart__data__gxVD2"};